import React from "react";
import { Container } from "react-bootstrap";
import "./Getnotified.css";

const Getnotified = () => {
  return (
    <>
      <section className="get-notified-section">
        <Container>
          <section className="subscriber-wrapper">
            <Container>
                <div className="row align-items-center">
                    <div className="col-lg-12">
                        <div className="subscriber-wrapper-content">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-4 col-lg-5">
                                    <h3>
                                        <strong>Get Notified !</strong>
                                    </h3>
                                    <p>Subscribe and get notified for latest blogs & updates.</p>
                                </div>
                                <div className="col-12 col-md-4 col-lg-5">
                                    <div className="subscriber-input">
                                        <div className="form-group">
                                            <div className="email_posts_subscribers">
                                                <input type="email" placeholder="Enter Your Email ID" className="form-control"/>
                                                <input type="button" value="Subscribe" className="email-button"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
          </section>
        </Container>
      </section>
    </>
  );
};

export default Getnotified;
